<div class="row searchable-container" ng-controller="CustomerCardController" ng-init="get()">
	<div class="mr-3" ng-repeat="item in cards" ng-class="{'disabled-card' : loading}">
		<div class="cart-container" ng-class="{ 'primary': $index === 0, 'others': $index != 0 }">
			<div class="cart-header">
				<img ng-src="/cards/{{item.brand}}.png" alt="" width="100px">
				<div class="cart-settings dropdown">
					<a href="#" class="dropdown-toggle" data-toggle="dropdown" role="button" aria-expanded="false">
						<i class="icon-more-2-fill"></i>
					</a>
					<ul class="dropdown-menu dropdown-menu-form p10 w200" role="menu">
						<li>
							<a href="#" ng-if="stcustomer.default_source != item.id" ng-click="primary(item.id)">Make Primary</a>
							<!-- <a href="#">Update</a> -->
							<a href="#" ng-click="delete(item.id)">Delete</a>
						</li>
					</ul>
				</div>
			</div>
			<div class="cart-body">
				<div class="primary-cart-badge" ng-if="stcustomer.default_source == item.id">
					<i class="icon-check-fill"></i> PRIMARY
				</div>
				<!-- <h5>Card Number</h5>
				<p>•••• •••• •••• {{ item.last4 }}</p> -->
			</div>
			<div class="cart-footer">
				<div class="cart-name">
					<!-- <h5>Card Holder</h5>
					<p>{{ item.name }}</p> -->
					<h5>Card Number</h5>
					<p>•••• •••• •••• {{ item.last4 }}</p>
				</div>
				<div class="cart-exp">
					<h5>Expire Date</h5>
					<p>{{ item.exp_month }} / {{ item.exp_year }}</p>
				</div>
			</div>
		</div>
	</div>
	<div class="mr-3">
		<a class="cart-container new" href="#" data-toggle="modal" data-target="#newCardModal">
			<i class="icon-add"></i>Add Card
		</a>
	</div>
	<div class="modal right" id="newCardModal" tabindex="-1" role="dialog" aria-labelledby="newCardModalLabel">
		<div class="modal-dialog modal-lg" role="document">
			<div class="modal-content">
				<div class="modal-header">
					<div class="modal-title">
						<h4 id="newCardModalLabel">Add Card</h4>
					</div>
					<button type="button" class="close" data-dismiss="modal" aria-label="Close">
						<i class="icon-close-circle"></i>
					</button>
				</div>
				<div class="modal-body">
					<div class="modal-body-container">
						<div class="loading" ng-if="loadingCard">
							<div id="global_loader" class="glb-ldr-prt">
								<div class="gl-ldr-cld">
									<div class="gl-ldr-ctr">
										<div class="gl-loader"></div>
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="col-md-12">
								<div class="cart-container empty">
									<div class="cart-header">
									</div>
									<div class="cart-body">
										<h5>Card Number</h5>
										<p ng-bind="getMaskedCardNumber()"></p>
									</div>
									<div class="cart-footer">
										<div class="cart-name">
											<h5>Card Holder</h5>
											<p>{{ card.name }}</p>
										</div>
										<div class="cart-exp">
											<h5>Expire Date</h5>
											<p>{{ card.expMonth }} {{ (card.expYear && card.expMonth) && '/' }}
												{{ card.expYear.length === 4 ? card.expYear.toString().split('').slice(-2).join('') : "" }}
											</p>
										</div>
									</div>
								</div>
							</div>
						</div>
						<div class="row">
							<div class="form-group floating section col-md-12">
								<input placeholder="Full Name" type="text" class="form-control " ng-model="card.name"
									name="name" required />
								<label>Full Name</label>
							</div>
							<div class="form-group floating section col-md-12">
								<input placeholder="Card Number" type="text" class="form-control "
									ng-model="card.cnumber" ui-mask="9999 9999 9999 9999" ui-mask-placeholder
									ui-mask-placeholder-char=" " required ng-minlength="16" />
								<label>Card Number</label>
							</div>
							<div class="section col-md-12">
								<div class="row">
									<div class="form-group floating col-md-6 pr-2">
										<input placeholder="MM" type="text" class="form-control " ui-mask="99"
											ui-mask-placeholder ui-mask-placeholder-char=" " ng-model="card.expMonth"
											name="expMonth" required />
										<label>MM</label>
									</div>
									<div class="form-group floating col-md-6 pl-2">
										<input placeholder="YYYY" type="text" class="form-control " ui-mask="9999"
											ui-mask-placeholder ui-mask-placeholder-char=" " ng-model="card.expYear"
											name="expYear" required />
										<label>YYYY</label>
									</div>
								</div>
							</div>
							<div class="form-group floating section col-md-12">
								<input placeholder="CVC" type="text" ui-mask="999" ui-mask-placeholder
									ui-mask-placeholder-char=" " class="form-control " ng-model="card.cvc" name="cvc"
									required ng-minlength="3" ng-maxlength="3" />
								<label>CVC</label>
							</div>
							<div class="col-md-12">
								<button type="submit" class="btn" ng-click="add()">Add Card</butto>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>